//common
import './common';

//components
import './blocks/slider-banner-main'
import './blocks/slider-product-recipes'
import './blocks/slider-article'
import './blocks/slider-product'
import './blocks/tab'
import './blocks/media'
import './blocks/fancybox'

document.addEventListener('click', e => {
    const popupMain = e.target.closest('._popup-main')
    if (popupMain && (e.target.closest('._popup-main-close') || !e.target.closest('._popup-main-content'))) {
        popupMain.classList.add('hidden')
    }
})